import { Box } from "@mui/material";
import { MouseEvent, useCallback } from "react";

import DriveAssetView from "./DriveAssetView";
import DriveDirectoryView from "./DriveDirectoryView";
import DriveFileView from "./DriveFileView";
import DriveStyleView from "./DriveStyleView";
import { DriveItem, DriveViewType } from "./types";

type DriveItemViewProps = {
  viewType: DriveViewType;
  item: DriveItem;
  isSelected: boolean;
  isSelectable: boolean;
  onClick: (event: MouseEvent, item: DriveItem) => void;
  onDoubleClick: (event: MouseEvent, item: DriveItem) => void;
  onContextMenu: (event: MouseEvent, item: DriveItem) => void;
  style?: any;
};

export default function DriveItemView({
  viewType,
  item,
  isSelected,
  isSelectable,
  onClick,
  onDoubleClick,
  onContextMenu,
  style,
}: DriveItemViewProps) {
  const onClickItem = useCallback(
    (event: MouseEvent) => {
      onClick(event, item);
    },
    [item, onClick],
  );

  const onDoubleClickItem = useCallback(
    (event: MouseEvent) => {
      onDoubleClick(event, item);
    },
    [item, onDoubleClick],
  );

  const onContextMenuItem = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      onContextMenu(event, item);
    },
    [item, onContextMenu],
  );

  const renderView = () => {
    switch (item.__typename) {
      case "File":
        return (
          <DriveFileView
            viewType={viewType}
            file={item}
            isSelected={isSelected}
            isSelectable={isSelectable}
            onClick={onClickItem}
            onDoubleClick={onDoubleClickItem}
            onContextMenu={onContextMenuItem}
          />
        );
      case "Asset":
        return (
          <DriveAssetView
            viewType={viewType}
            asset={item}
            isSelected={isSelected}
            isSelectable={isSelectable}
            onClick={onClickItem}
            onDoubleClick={onDoubleClickItem}
            onContextMenu={onContextMenuItem}
          />
        );
      case "Directory":
        return (
          <DriveDirectoryView
            viewType={viewType}
            directory={item}
            isSelected={isSelected}
            isSelectable={isSelectable}
            onClick={onClickItem}
            onDoubleClick={onDoubleClickItem}
            onContextMenu={onContextMenuItem}
          />
        );
      case "Style":
      case "ReferenceSet":
        return (
          <DriveStyleView
            viewType={viewType}
            style={item}
            isSelected={isSelected}
            isSelectable={isSelectable}
            onClick={onClickItem}
            onDoubleClick={onDoubleClickItem}
            onContextMenu={onContextMenuItem}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box
      style={style}
      sx={{
        display: viewType === "table" ? "table" : "flex",
        width: viewType === "table" ? "calc(100% - 8px) !important" : "100%",
        padding: "2px",
        pointerEvents: "auto",
        fontSize: "13px",
      }}
    >
      {renderView()}
    </Box>
  );
}
